<template>
  <div>
    <slot></slot>

    <div class="w3-main w3-padding-small" style="margin-left:200px">

      <div class="main-box" style="padding: 50px 0 0 0">

        <div class="w3-large">
          <b>Profile</b>
        </div>

        <div class="" style="font-size: 12px">
          Manage your Planar profile
        </div>

        <hr>

        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="w3-container" @submit.prevent="handleSubmit(updateUser)">

            <div class="" style="font-size: 13px">
              <b>Profile picture</b>

              <label for="file-input" style="cursor: pointer;">
                <div class="">
                  <span v-if="user.image">
                    <img :src="profile_image" class="img" alt=""/>
                  </span>

                  <span v-else>
                    <span v-html="profile_image_text" class="w3-badge w3-padding-large image-1">
                    </span>
                  </span>
                </div>
                <input type="file" ref="image" id="file-input" v-on:change="handleFileUpload()" style="display: none;">
                <span class="w3-text-red err" v-if="'image' in profileFormErr">{{ profileFormErr['image'][0] }}</span>
              </label>
            </div>

            <ValidationProvider name="User Email" rules="required|min:3|max:150" v-slot="{ errors }">
            <div class="w3-margin-top" style="font-size: 13px">
              <b>Email</b>

              <div class="">
                <input v-model="formD.email" required type="text" name="" value="" class="w3-input">
                <span class="w3-text-red">{{ errors[0] }}</span>
                <span class="w3-text-red err" v-if="'email' in profileFormErr">{{ profileFormErr['email'][0] }}</span>

              </div>
            </div>
            </ValidationProvider>


            <ValidationProvider name="First Name" rules="min:3" v-slot="{ errors }">
            <div class="w3-margin-top" style="font-size: 13px">
              <b>Firstname</b>

              <div class="">
                <input v-model="formD.first_name" type="text" name="" value="" class="w3-input">
                <span class="w3-text-red">{{ errors[0] }}</span>
                <span class="w3-text-red err" v-if="'first_name' in profileFormErr">{{ profileFormErr['first_name'][0] }}</span>

              </div>
            </div>
            </ValidationProvider>

            <div class="w3-margin-top" style="font-size: 13px">
              <b>Lastname</b>

              <div class="">
                <input v-model="formD.last_name" type="text" name="" value="" class="w3-input">
                <span class="w3-text-red err" v-if="'last_name' in profileFormErr">{{ profileFormErr['last_name'][0] }}</span>

              </div>
            </div>


            <div class="w3-margin-top">
              <button type="submit" name="button">Update</button>
            </div>

          </form>
        </ValidationObserver>


        <!-- <div class="">Your Workspaces</div>
        <hr>
          <div v-for="(value, index) in workspaces" :key="index">
            <router-link
            :to="{ name: 'issues', params: {slug: value.slug} }"
            class="w3-redx"
            >
              {{ value.name }}
            </router-link>
          </div> -->
      </div>

    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  name: 'Profile',

  data(){
    return{
      image: '',
      formD: {
        email: '',
        first_name: '',
        last_name: '',
      },
      notificationSystem: {
        options: {
          success: {
            position: "bottomRight"
          },
          error: {
            position: "bottomRight"
          },
        }
      },
    }
  },

  methods: {
    ...mapActions('auth', ['editUser']),
    updateUser: function (){
        let form = new FormData();
        form.append('email', this.formD.email)
        form.append('first_name', this.formD.first_name)
        form.append('last_name', this.formD.last_name)

        if (this.image) {
          form.append('image', this.image)
        }
        const payload = {data: form, user_id: this.user.id}
        this.editUser(payload)
    },
    handleFileUpload: function () {
      this.image = this.$refs.image.files[0]
    }
    // uploadFile: function () {
    //   console.log(1212);
    // }
  },

  mounted: function () {

  },

  created: function () {
    this.formD.email = this.user.email
    this.formD.first_name = this.user.first_name
    this.formD.last_name = this.user.last_name
    this.formD.id = this.user.id

  },

  watch: {
    watchMessage(message){
      if (message == 1) {
        this.$toast.success(' ', 'Profile updated.', this.notificationSystem.options.success)
      }else if (message == 2) {
        this.$toast.error(' ', 'Correct the above errors.', this.notificationSystem.options.error)
      }
    }
  },

  computed: {
    ...mapGetters('auth', ['auth_state', 'user', 'workspaces', 'server_url']),
    ...mapState('auth', ['profileFormErr', 'profileFormStatus']),

    profile_image: function () {
      // return this.server_url + this.user.image;
      // alert(this.user.image)
      return this.user.image;
    },

    profile_image_text: function () {
      return this.user.email.substring(0,2).toUpperCase();
    },

    watchMessage: function () {
      return this.profileFormStatus;
    }

  }
}
</script>



<style scoped>
.img{
  border-radius: 50%;
  width: 120px;
  height: 120px;
}

.err{
  text-transform: capitalize;
}

button{
  background-color: #5e6ad2;
  color: white;
  border: none;
  border-radius: 3px;
  padding: 5px 20px 5px 20px;
  font-size: 12px
}

input{
  width: 100%
}

.main-box{
  max-width: 700px;
  margin: 0 auto;
}

.image-1{
  margin-top:5px;background-color:#e57bb3;font-size: 80px
}
</style>
